module.exports = __webpack_public_path__ + "img/103_doc_back.271a16e2.svg";